import React, { Component } from "react";

export default class PageSubTitle extends Component {
  render() {
    const { children, center } = this.props;
    let className = ["page-subtitle"];
    if (center) {
      className.push("page-subtitle-centralized");
    }
    return <div className={className.join(" ")}>{children}</div>;
  }
}



// WEBPACK FOOTER //
// ./src/_components/UI/PageSubTitle/index.js